import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cooperate" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "logo-view" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "kfhz" }
const _hoisted_7 = { class: "open-cooperation-box" }

import { ref, onMounted } from 'vue'
import OpenCooperation from '@/components/mobile/OpenCooperation.vue';
import { asynchronousRetrieval } from '@/utils'

export default /*@__PURE__*/_defineComponent({
  __name: 'CollaborativeView',
  setup(__props) {

const loadUrl: any = ref({})

onMounted(async () => {
  const partners1: any = await asynchronousRetrieval('nfznxr-images/partners-1.png');
  const partners2: any = await asynchronousRetrieval('nfznxr-images/partners-2.png');
  const cooperate_bg: any = await asynchronousRetrieval('nfznxr-images/cooperate-bg.jpg');
  const open_cooperation_bg: any = await asynchronousRetrieval('nfznxr-images/open-cooperation-bg.png');
  loadUrl.value = { partners1, partners2, cooperate_bg, open_cooperation_bg }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: loadUrl.value.cooperate_bg
    }, null, 8, _hoisted_2),
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "hyst title-font-style-m" }, "行业生态", -1)),
    _createElementVNode("div", _hoisted_3, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "hzhb title-font-style-m" }, "合作伙伴", -1)),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "level2-title" }, "数智行业头部品牌", -1)),
      _createElementVNode("img", {
        class: "partners",
        src: loadUrl.value.partners1
      }, null, 8, _hoisted_4),
      _cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "level2-title",
        style: {"margin-top":"44rem"}
      }, "B端/G端合作客户", -1)),
      _createElementVNode("img", {
        class: "partners",
        src: loadUrl.value.partners2
      }, null, 8, _hoisted_5),
      _createElementVNode("div", _hoisted_6, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "title-font-style-m" }, "开放合作", -1)),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "level2-title" }, "欢迎携手凝丰智能 共建数智化生态", -1)),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(OpenCooperation)
        ])
      ])
    ])
  ]))
}
}

})